import ApolloClient from 'apollo-boost'

const apolloClient = new ApolloClient({
  // You should use an absolute URL here
  uri: 'https://graphql.datocms.com',
  headers: {
    Authorization: 'Bearer 984bca2a3f1c9f808063b6dd4ab234'
  }
})

export default apolloClient
